import React from 'react';

export const CompletedIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM14.1509 6.10523C13.6487 5.77499 12.9726 5.92896 12.6629 6.4441L9.34337 11.9653L7.26306 9.69489C6.85221 9.2465 6.15029 9.23157 5.72075 9.6621C5.31758 10.0662 5.30378 10.716 5.68943 11.1368L8.66223 14.3809C9.17414 14.9395 10.0794 14.8485 10.4698 14.1991L14.4764 7.53442C14.7689 7.04785 14.6253 6.41714 14.1509 6.10523Z"
      fill="#01AF6A"
    />
  </svg>
);
